// Before page has loaded

// Remove dark header from project singles
if ($("body").hasClass("single-project")) {
    $("header").removeClass("dark-header").removeClass("dark");
}

// After page has loaded

$(document).ready(() => {
    // Scroll top
    $("#scrollTop").on("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    });

    // Menu toggle
    $(".hamburger").on("click", () => {
        $(".hamburger").toggleClass("is-active");
        $(".menu-panel").toggleClass("is-active");

        if ($(".menu-panel").hasClass("is-active")) {
            $("body").css("overflow", "hidden");
        } else {
            $("body").css("overflow", "auto");
        }

        if ($("header").hasClass("dark-header")) {
            $("header").toggleClass("dark");
        }
    });

    // Background image on hover
    $("#menu-main-menu > li").on("mouseenter", function () {
        if ($(this).hasClass("menu-item-has-children")) {
            $(this).addClass("is-active");
        } else {
            $(".menu-item").removeClass("is-active");
        }

        let id = $(this).attr("id");
        id = id.replace("menu-item-", "");

        if ($("#bg-" + id).css("display") == "block") {
        } else {
            $(".menu-panel__background").fadeOut();

            if ("#bg-" + id) {
                $("#bg-" + id).fadeIn();
            } else {
                $("#bg-54").fadeIn();
            }
        }
    });

    // Show submenu
    $("#menu-main-menu > li").on("click", function (e) {
        if ($(this).hasClass("menu-item-has-children")) {
            if ($(this).hasClass("is-active")) {
                $(".menu-item").removeClass("is-active");
            } else {
                $(this).addClass("is-active");
            }
        }
    });

    // Hide background image on hover
    $("#shareholder").on("mouseenter", function () {
        $(".menu-panel__background").fadeOut();
    });

    // Home Hero Slider
    $(".home-hero__slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        asNavFor: ".home-hero__nav",
    });

    $(".home-hero__nav").slick({
        asNavFor: ".home-hero__slider",
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $(".home-hero__nav-prev"),
        nextArrow: $(".home-hero__nav-next"),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    // Latest News Slider
    $(".latest-news__slider").slick({
        dots: false,
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        prevArrow: $(".latest-news__nav-prev"),
        nextArrow: $(".latest-news__nav-next"),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    centerMode: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    var gallerySlider = $(".gallery__carousel");

    // Latest News Slider
    gallerySlider.slick({
        dots: false,
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: $(".gallery__nav-prev"),
        nextArrow: $(".gallery__nav-next"),
    });

    $("[data-target]").click(function () {
        var target = $(this).attr("data-target");
        $(".tabs__panel").removeClass("tabs__panel--active");
        $(".tabs__title button").removeClass("active");

        $(this).addClass("active");
        $("#" + target).addClass("tabs__panel--active");
    });

    $(".portfolio-card").mouseenter(function () {
        var video = $(this).find("video").get(0);

        $(this).find(".image").css("opacity", "0");
        $(this).find("video").get(0).play();
    });

    $(".portfolio-card").mouseleave(function () {
        $(this).find(".image").css("opacity", "1");
        $(this).find("video").get(0).pause();
    });

    $(".charity__block--images").slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
        ],
    });

    // Progress bar
    $(".latest-news__slider").on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }
        var i = 1;
        if (currentSlide) {
            i = currentSlide + 1;
        }
        var totalSlides = slick.$dots[0].children.length;
        if (i < 10) {
            $(".carousel-progress__current.ln").text("0" + i);
        } else {
            $(".carousel-progress__current.ln").text(i);
        }
        $(".carousel-progress__progress.ln").css("width", Math.floor((i / totalSlides) * 100) + "%");
    });

    // Progress bar
    $(".gallery__carousel").on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }
        var i = 1;
        if (currentSlide) {
            i = currentSlide + 1;
        }
        var totalSlides = slick.$dots[0].children.length;
        if (i < 10) {
            $(".carousel-progress__current.g").text("0" + i);
        } else {
            $(".carousel-progress__current.g").text(i);
        }
        $(".carousel-progress__progress.g").css("width", Math.floor((i / totalSlides) * 100) + "%");
    });

    // History Sliders
    $(".history__gallery").each(function (index) {
        $(".history-swiper-" + index).slick({
            dots: false,
            focusOnSelect: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            prevArrow: $(".history-swiper-prev-" + index),
            nextArrow: $(".history-swiper-next-" + index),
        });

        $(".history-swiper-" + index).on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
            if (!slick.$dots) {
                return;
            }
            var i = 1;
            if (currentSlide) {
                i = currentSlide + 1;
            }
            var totalSlides = slick.$dots[0].children.length;
            if (i < 10) {
                $(".carousel-progress__current.hist-" + index).text("0" + i);
            } else {
                $(".carousel-progress__current.hist-" + index).text(i);
            }
            $(".carousel-progress__progress.hist-" + index).css("width", Math.floor((i / totalSlides) * 100) + "%");
        });
    });

    // Login Form Page Placeholders
    if ($("#user_login").length > 0) {
        $("#user_login").attr("placeholder", "Email");
        $("#user_pass").attr("placeholder", "Password");
    }

    // Toggle map/grid on portfolio
    $(".portfolio__header--buttons button").on("click", function () {
        let type = $(this).attr("data-type");
        $(".portfolio__header--buttons button").removeClass("is-active");
        $(this).addClass("is-active");
        if (type === "grid") {
            $(".portfolio__grid").show().css("display", "grid");
            $(".portfolio__map").hide();
        } else {
            $(".portfolio__grid").hide();
            $(".portfolio__map").show();
            initMap();
        }
    });

    // The Team Grids
    $(".team__buttons--button").on("click", function () {
        let type = $(this).attr("data-type");
        $(".team__buttons--button").removeClass("is-active");
        $(this).addClass("is-active");
        $(".team__grid").hide();
        $("#" + type)
            .show()
            .css("display", "grid");
    });

    // Shareholder Information Filter
    // watch select
    $("#year-filter").on("change", function () {
        let year = $(this).val();
        if (year === "all") {
            $(".shareholder__information--card").show();
        } else {
            $(".shareholder__information--card").hide();
            $(".shareholder__information--card." + year).show();
        }
    });
});
